import React from "react";
import { Box } from "@mui/material";
import TitleBar from "../../components/navbar/TitleBar";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import Footer from "../../components/common/Footer";
import AttendantsMain from "../../components/attendants/AttendantsMain";

export default function SchoolBusAttendants() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      <Box>
        <TitleBar />
        <SchoolBusNavMenu />
        <AttendantsMain school />
      </Box>
      <Footer />
    </Box>
  );
}
